import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { isDark } from '../common/utils';
import styles from './page-header.module.scss';
const PageHeader = ({ title, children, RTL = false, size = 'sm', icon, }) => {
    const isDarkMode = useMemo(() => isDark(), []);
    const headerClass = useMemo(() => {
        return classNames(styles.page_header, {
            [styles.rtl]: RTL,
            [styles[`${size}`]]: size,
        });
    }, []);
    const titleClass = useMemo(() => {
        return classNames(styles.title);
    }, []);
    const headerIconClass = useMemo(() => {
        return classNames(styles.icon, {
            [styles[`icon_${size}`]]: true,
        });
    }, []);
    const contentClass = useMemo(() => classNames(styles.content, {
        [styles.dark]: isDarkMode,
    }), []);
    return (_jsxs("header", { className: headerClass, children: [_jsxs("div", { className: styles.title_container, children: [icon && _jsx("span", { className: headerIconClass, children: icon }), _jsx("h2", { className: titleClass, children: title })] }), _jsx("div", { className: contentClass, children: children })] }));
};
PageHeader.displayName = 'PageHeader';
export { PageHeader };
